import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingWhatsapp from "@/components/FloatingWhatsapp";
import { User, MapPin, ShieldCheck } from "lucide-react";

const HPL_PLAYERS = [
  { name: "Sahil", team: "Gaji Club Harsore", stats: "168 runs (SR: 270.97, 18 sixes) and 11 wickets (Econ: 5.10)" },
  { name: "Mangla Ram Bhinchar", team: "G B11 Harsore", stats: "127 runs (Avg: 63.50) and 5 wickets" },
  { name: "Abhishek Gena", team: "Star 11 Harsore", stats: "122 runs (SR: 190.63) and 5 wickets" },
  { name: "01shahbaz", team: "Gaji Club Harsore", stats: "77 runs (SR: 192.50) and 7 wickets (Econ: 6.40)" },
  { name: "Sarwan Megwal", team: "Dayma Kings 11", stats: "98 runs (SR: 204.17) and 5 wickets (Econ: 4.80)" },
  { name: "Jp", team: "Panwar 11 Harsore", stats: "9 wickets in 7 overs (Avg: 3.56, Econ: 4.57)" },
  { name: "Bhuvnesh Prajapat", team: "Khan 11 Harsore", stats: "10 wickets, best 4 wickets" },
  { name: "Mukesh Gwala", team: "Mansuri 11 Harsore", stats: "71 runs (9 sixes) and 7 wickets" },
  { name: "Satyendra Singh Gena", team: "Star 11 Harsore", stats: "39 runs (SR: 195.00) and 8 wickets" },
  { name: "Indrajit", team: "Panwar 11 Harsore", stats: "83 runs (Avg: 83.00, SR: 197.62)" },
  { name: "Ishwar Dayma", team: "Dayma Kings 11", stats: "83 runs (SR: 244.12, 6 sixes)" },
  { name: "Nilesh", team: "Panwar 11 Harsore", stats: "74 runs (SR: 176.19, 9 sixes)" },
  { name: "Tikam", team: "TYSON 11 Harsore", stats: "45 runs (SR: 236.84, 5 sixes)" },
  { name: "Amar Bhambu Raj Police", team: "Khan 11 Harsore", stats: "79 runs (SR: 154.90)" },
  { name: "Hujur", team: "G B11 Harsore", stats: "70 runs and 3 wickets" },
  { name: "BHAMSA", team: "G B11 Harsore", stats: "69 runs (SR: 191.67) and 4 wickets" },
  { name: "Sethu Tailor", team: "Nagauri Bulls", stats: "65 runs (SR: 158.54)" },
  { name: "Islam Khan", team: "Star 11 Harsore", stats: "65 runs (SR: 171.05)" },
  { name: "Nilesh Pareek", team: "Nagauri Bulls", stats: "63 runs (SR: 161.54)" },
  { name: "Saif Ali Khan", team: "Mansuri 11 Harsore", stats: "59 runs and 7 wickets" },
  { name: "Sanjay Prajapat", team: "TYSON 11 Harsore", stats: "54 runs and 1 wicket" },
  { name: "Shamsher 313", team: "RR 11 Harsore", stats: "53 runs and 4 wickets" },
  { name: "Sharif Khan", team: "Khan 11 Harsore", stats: "53 runs (SR: 165.63)" },
  { name: "Shyam Pratap Singh Rathore", team: "Nagauri Bulls", stats: "49 runs (SR: 181.48)" },
  { name: "Rdx Mahendra Cricketer", team: "TYSON 11 Harsore", stats: "48 runs and 4 wickets" },
  { name: "Babu", team: "Mansuri 11 Harsore", stats: "43 runs and 8 wickets (Econ: 6.75)" },
  { name: "Raju Dayma Bajwas", team: "G B11 Harsore", stats: "36 runs and 4 wickets" },
  { name: "Inderjeet", team: "Panwar 11 Harsore", stats: "35 runs and 7 wickets (Econ: 6.71)" },
  { name: "Mukesh Kudiya", team: "Mansuri 11 Harsore", stats: "35 runs" },
  { name: "Prahlad", team: "G B11 Harsore", stats: "34 runs in 1 innings (SR: 226.67)" },
  { name: "Narendra", team: "Nagauri Bulls", stats: "33 runs and 2 wickets" },
  { name: "CR Jaat", team: "Dayma Kings 11", stats: "32 runs (SR: 152.38)" },
  { name: "Narendra Gadwal", team: "Gaji Club Harsore", stats: "31 runs (SR: 163.16)" },
  { name: "Bhanu Choudhary", team: "Panwar 11 Harsore", stats: "30 runs (SR: 125.00)" },
  { name: "Md Sharif", team: "Nagauri Bulls", stats: "30 runs and 3 wickets" },
  { name: "Tikam Chand Bajwas", team: "TYSON 11 Harsore", stats: "29 runs in 1 innings (SR: 241.67) and 1 wicket" },
  { name: "Momadh Ali", team: "Star 11 Harsore", stats: "27 runs (SR: 122.73)" },
  { name: "Parsaram Kudiya", team: "TYSON 11 Harsore", stats: "25 runs (SR: 156.25)" },
  { name: "Shahrukh", team: "Gaji Club Harsore", stats: "4 wickets in 5 overs (Strike Rate: 7.50)" },
  { name: "Harendra", team: "Khan 11 Harsore", stats: "2 wickets in 1 over for 2 runs (Econ: 2.00)" },
  { name: "Rajesh Matwa", team: "Star 11 Harsore", stats: "17 runs and 2 wickets in 3.3 overs" },
  { name: "Naresh", team: "TYSON 11 Harsore", stats: "24 runs (SR: 120.00)" },
  { name: "Surendre", team: "Star 11 Harsore", stats: "18 runs and 7 wickets" },
];

export default function HplPlayers() {
  const [settings, setSettings] = useState({});
  const [verified, setVerified] = useState([]);
  const [loadingList, setLoadingList] = useState(true);
  const [selected, setSelected] = useState(null);
  const [photoDataUrl, setPhotoDataUrl] = useState("");
  const [role, setRole] = useState("");
  const [utr, setUtr] = useState("");

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
    setLoadingList(true);
    api.get("/hpl-registrations/verified")
      .then((r) => setVerified(r.data || []))
      .catch(() => setVerified([]))
      .finally(() => setLoadingList(false));
  }, []);

  const openVerified = (reg) => {
    const preload = HPL_PLAYERS.find((p) => p.name.toLowerCase() === reg.player_name.toLowerCase());
    setSelected({
      name: reg.player_name,
      team: reg.team || preload?.team || "",
      stats: reg.stats || preload?.stats || "",
    });
    setPhotoDataUrl(reg.photo_data_url || "");
    setRole(reg.role || "");
    setUtr(reg.utr || "");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const closePlayer = () => setSelected(null);

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Navbar />
      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-28 pb-20">
        {!selected ? (
          <>
            <div className="text-xs uppercase tracking-[0.4em] text-[#39FF14]">Harsore Premier League</div>
            <h1 className="font-display text-5xl md:text-6xl mt-3">HPL <span className="text-[#FFD700]">Selected Players</span></h1>
            <p className="mt-3 text-white/70">Officially verified players eligible for the NDPL auction.</p>

            {loadingList ? (
              <div className="mt-8 text-white/50" data-testid="hpl-loading">Loading…</div>
            ) : verified.length === 0 ? (
              <div className="mt-8 p-8 border border-dashed border-white/15 bg-[#0B132B] text-center text-white/60" data-testid="hpl-empty">No verified HPL players yet. Check back soon.</div>
            ) : (
              <div className="mt-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="hpl-verified-grid">
                {verified.map((r) => (
                  <button key={r.id} onClick={() => openVerified(r)} data-testid={`hpl-card-${r.id}`}
                    className="group text-left relative overflow-hidden border border-white/10 bg-[#0B132B] hover:border-[#39FF14] transition-colors rounded-lg">
                    <div className="aspect-[3/4] bg-black/40 relative overflow-hidden">
                      {r.photo_data_url ? (
                        <img src={r.photo_data_url} alt={r.player_name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                      ) : (
                        <div className="w-full h-full grid place-items-center text-white/30"><User size={48} /></div>
                      )}
                      <div className="absolute top-3 left-3 px-2 py-1 bg-[#39FF14] text-black text-[10px] uppercase tracking-widest font-bold flex items-center gap-1"><ShieldCheck size={10}/>Verified</div>
                    </div>
                    <div className="p-4">
                      <div className="font-display text-2xl leading-tight">{r.player_name}</div>
                      <div className="mt-1 text-[#FFD700] text-xs uppercase tracking-widest">{r.role}</div>
                      <div className="mt-2 flex items-center gap-1 text-xs text-white/50"><MapPin size={12}/>{r.team}</div>
                    </div>
                  </button>
                ))}
              </div>
            )}
          </>
        ) : (
          <div className="max-w-2xl mx-auto">
            <button onClick={closePlayer} className="flex items-center gap-2 text-xs uppercase tracking-widest text-white/60 hover:text-[#39FF14]">←Back</button>

            <div className="mt-4 p-6 bg-[#0B132B] border border-white/10 rounded">
              <h2 className="font-display text-4xl" data-testid="hpl-player-name">{selected.name}</h2>
              <div className="mt-1 text-[#FFD700] font-display text-xl">{selected.team}</div>
              <div className="mt-3 text-white/80" data-testid="hpl-player-stats">{selected.stats}</div>
            </div>

            <div className="mt-6 p-6 bg-gradient-to-br from-[#0B132B] to-[#151F3D] border border-[#39FF14]/50 rounded" data-testid="hpl-verified-card">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-[#39FF14] text-black grid place-items-center"><ShieldCheck size={24}/></div>
                <div>
                  <div className="text-xs uppercase tracking-[0.3em] text-[#39FF14]">Verified Player</div>
                  <div className="font-display text-2xl">Eligible for NDPL Auction</div>
                </div>
              </div>
              <div className="mt-6 grid md:grid-cols-2 gap-5">
                <div>
                  <div className="text-xs uppercase tracking-widest text-white/60 mb-2">Player Photo</div>
                  {photoDataUrl
                    ? <img src={photoDataUrl} alt={selected.name} className="w-full max-h-64 object-contain bg-black/30 border border-white/10"/>
                    : <div className="w-full h-40 grid place-items-center border border-dashed border-white/15 text-white/40 text-xs">No photo</div>}
                </div>
                <div className="space-y-2 text-sm">
                  <div><span className="text-white/50 uppercase text-xs tracking-widest">Player Name: </span>{selected.name}</div>
                  <div><span className="text-white/50 uppercase text-xs tracking-widest">Team / Club: </span><span className="text-[#FFD700]">{selected.team}</span></div>
                  <div><span className="text-white/50 uppercase text-xs tracking-widest">Playing Role: </span>{role}</div>
                  <div><span className="text-white/50 uppercase text-xs tracking-widest">Statistics: </span>{selected.stats}</div>
                  <div><span className="text-white/50 uppercase text-xs tracking-widest">Payment Status: </span><span className="text-[#39FF14] font-bold">Verified</span></div>
                  <div><span className="text-white/50 uppercase text-xs tracking-widest">Auction Registration: </span><span className="text-[#39FF14] font-bold">Verified</span></div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer settings={settings} />
      <FloatingWhatsapp />
    </div>
  );
}
